// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("/static/link.png", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `* {
  box-sizing: border-box;
}

body, html {

  font-family: "Helvetica Neue", Helvetica, Arial, sans-serif;

  font-size: 12px;

  height: 100%;
  padding: 0;
  margin: 0;
}

a:link {
  text-decoration: none;
}

.content,
.content > div, body {
  width: 100%;
  height: 100%;
  overflow: hidden;
  display: flex;

}


.content > .message {
  text-align: center;
  display: table;

  font-size: 16px;
  color: #111;
}

.content > .message .note {
  vertical-align: middle;
  text-align: center;
  display: table-cell;
}

.content .error .details {
  max-width: 500px;
  font-size: 12px;
  margin: 20px auto;
  text-align: left;
}

.content .error pre {
  border: solid 1px #CCC;
  background: #EEE;
  padding: 10px;
}

.content:not(.with-error) .error,
.content.with-error .intro,
.content.with-diagram .intro {
  display: none;
}


.content .canvas,
.content.with-error .canvas {
  visibility: hidden;
}

.content.with-diagram .canvas {
  visibility: visible;
}

.buttons {
  position: fixed;
  bottom: 20px;
  left: 20px;

  padding: 0;
  margin: 0;
  list-style: none;
}

.buttons > li {
  display: inline-block;
  margin-right: 10px;
}
.buttons > li > a {
  background: #DDD;
  border: solid 1px #666;
  display: inline-block;
  padding: 5px;
}

.buttons a {
  opacity: 0.3;
}

.buttons a.active {
  opacity: 1.0;
  cursor: pointer;
}

/* Added Styles */

.cat {
  background-size: contain;
  background-repeat: no-repeat;
  background-position: center;
  width: 90%;
  height: 90%;
}

.djs-outline {
  visibility: hidden !important;
}

.djs-palette {
  max-height: 90vh;
  overflow-y: scroll;
  width: 11rem !important;
  /* background-color: #2F3134; */
  border-radius: 15px;
}

.djs-palette .group {
  margin-left: 6%;
}

.entry {
  flex-basis: 40%;
  margin-right: 3px;
  margin-left: 3px;
}


#js-import-diagram {
  display: flex;
  justify-content: center;
  align-items: center;
  align-content: center;
}

.icon-color-picker {
  width: 20px;
  height: 20px;
}

.djs-context-pad {
  background-color: #f7f7f8;
  padding: 10px;
  border-radius: 15px;
  border: 1px solid #e0e0e0;
  width: 12rem;
}

a > svg {
  width: 25px;
  height: 25px;
  padding-right: 5px;
}
/* 
[class^="bpmn-icon-"]:before, [class*=" bpmn-icon-"]:before {
  color: white;
}

.djs-context-pad .entry {
  background-color: #1f1f1f;
}

.hover, svg.new-parent, .canvas {
  background-color: #1F1F1F !important;
}

body, .note {
  background-color: #1F1F1F;
  color: white;
}

.djs-popup, .bpmn-replace {
  background-color: #1F1F1F;
} */

.LinkEvent {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_0___});
  background-size: 75%;
  background-repeat: no-repeat;
  background-position: center;
  width: 90%;
  height: 90%;
}

.djs-resizer-n, .djs-resizer-s, .djs-resizer-w, .djs-resizer-e {
  display: none;
}


/* .hover {
  border: #111 solid 1px;
} */

.dotted-hover {
  display: none;
}

.djs-element:hover .dotted-hover {
  display: block;
}

.selected .dotted-hover {
  display: block;
}

.line-selected {
  display: none;
}

.selected .line-selected{
  display: block;
}

rect.djs-selection-outline {
  display: none;
}

.djs-hit {
  cursor: default !important;
}

.drop-ok {
  cursor: grabbing !important;
  cursor: -webkit-grabbing !important;
}

textarea {
  resize: none;
  height: 100% !important;
  width: 100%;
  overflow: hidden;
}

.CodeMirror {
    height: 100%;
    max-width: 100%;
    color: #000;
    overflow: hidden;
}

.json-editor {
  position: absolute;
  top: 0;
  right: 0; /* Garante que a div esteja fixa no lado direito */
  height: 100%; /* Ajuste conforme necessário */
  border-left: 2px solid #ccc;
  background-color: #f9f9f9;
  min-width: 100px; /* Evita que colapse */
  display: flex;
  transform: translateX(100%); /* Começa fora da tela, à direita */
  transition: transform 0.3s ease-in-out; /* Animação suave ao deslizar */
}


.resizer {
  width: 10px;
  height: 100vh;
  cursor: ew-resize;
  background-color: #555;
}


.json-content {
  height: 100%; /* Defina a altura desejada */
  overflow: hidden; /* Permita o overflow para scroll */
  padding-top: 30px;
  position: relative; 
}


  .json-title {
    display: flex;
    justify-content: center; /* Center the content horizontally */
    align-items: center;
    padding: 5px;
    font-weight: bold;
    position: absolute;
    top: 0;
    right: 0;
    z-index: 2;
    width: 100%;
    background-color: #f9f9f9;
  }

  .json-title > p {
    margin: 0; /* Remove default margin */
  }

  .json-title > button {
    margin-left: auto; /* Push the button to the right */
  }

#save {
  background-color: #1c1c1c;
  color: white;
  border: none;
  border-radius: 3px;
  padding: 10px 20px;
  text-align: center;
  text-decoration: none;
  display: inline-block;
  font-size: 14px;
  margin: 4px 2px;
  cursor: pointer;
  position: absolute;
  top: 40px;
  right: 20px;
  z-index: 2;
  border: #444 solid 1px;
}

#save:hover {
  background-color: #222222;
}


`, "",{"version":3,"sources":["webpack://./src/style.css"],"names":[],"mappings":"AAAA;EACE,sBAAsB;AACxB;;AAEA;;EAEE,2DAA2D;;EAE3D,eAAe;;EAEf,YAAY;EACZ,UAAU;EACV,SAAS;AACX;;AAEA;EACE,qBAAqB;AACvB;;AAEA;;EAEE,WAAW;EACX,YAAY;EACZ,gBAAgB;EAChB,aAAa;;AAEf;;;AAGA;EACE,kBAAkB;EAClB,cAAc;;EAEd,eAAe;EACf,WAAW;AACb;;AAEA;EACE,sBAAsB;EACtB,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;EAChB,eAAe;EACf,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA;EACE,sBAAsB;EACtB,gBAAgB;EAChB,aAAa;AACf;;AAEA;;;EAGE,aAAa;AACf;;;AAGA;;EAEE,kBAAkB;AACpB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,YAAY;EACZ,UAAU;;EAEV,UAAU;EACV,SAAS;EACT,gBAAgB;AAClB;;AAEA;EACE,qBAAqB;EACrB,kBAAkB;AACpB;AACA;EACE,gBAAgB;EAChB,sBAAsB;EACtB,qBAAqB;EACrB,YAAY;AACd;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,YAAY;EACZ,eAAe;AACjB;;AAEA,iBAAiB;;AAEjB;EACE,wBAAwB;EACxB,4BAA4B;EAC5B,2BAA2B;EAC3B,UAAU;EACV,WAAW;AACb;;AAEA;EACE,6BAA6B;AAC/B;;AAEA;EACE,gBAAgB;EAChB,kBAAkB;EAClB,uBAAuB;EACvB,+BAA+B;EAC/B,mBAAmB;AACrB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,eAAe;EACf,iBAAiB;EACjB,gBAAgB;AAClB;;;AAGA;EACE,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,qBAAqB;AACvB;;AAEA;EACE,WAAW;EACX,YAAY;AACd;;AAEA;EACE,yBAAyB;EACzB,aAAa;EACb,mBAAmB;EACnB,yBAAyB;EACzB,YAAY;AACd;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;AACpB;AACA;;;;;;;;;;;;;;;;;;;;GAoBG;;AAEH;EACE,yDAAyC;EACzC,oBAAoB;EACpB,4BAA4B;EAC5B,2BAA2B;EAC3B,UAAU;EACV,WAAW;AACb;;AAEA;EACE,aAAa;AACf;;;AAGA;;GAEG;;AAEH;EACE,aAAa;AACf;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,0BAA0B;AAC5B;;AAEA;EACE,2BAA2B;EAC3B,mCAAmC;AACrC;;AAEA;EACE,YAAY;EACZ,uBAAuB;EACvB,WAAW;EACX,gBAAgB;AAClB;;AAEA;IACI,YAAY;IACZ,eAAe;IACf,WAAW;IACX,gBAAgB;AACpB;;AAEA;EACE,kBAAkB;EAClB,MAAM;EACN,QAAQ,EAAE,kDAAkD;EAC5D,YAAY,EAAE,+BAA+B;EAC7C,2BAA2B;EAC3B,yBAAyB;EACzB,gBAAgB,EAAE,sBAAsB;EACxC,aAAa;EACb,2BAA2B,EAAE,mCAAmC;EAChE,sCAAsC,EAAE,+BAA+B;AACzE;;;AAGA;EACE,WAAW;EACX,aAAa;EACb,iBAAiB;EACjB,sBAAsB;AACxB;;;AAGA;EACE,YAAY,EAAE,6BAA6B;EAC3C,gBAAgB,EAAE,mCAAmC;EACrD,iBAAiB;EACjB,kBAAkB;AACpB;;;EAGE;IACE,aAAa;IACb,uBAAuB,EAAE,oCAAoC;IAC7D,mBAAmB;IACnB,YAAY;IACZ,iBAAiB;IACjB,kBAAkB;IAClB,MAAM;IACN,QAAQ;IACR,UAAU;IACV,WAAW;IACX,yBAAyB;EAC3B;;EAEA;IACE,SAAS,EAAE,0BAA0B;EACvC;;EAEA;IACE,iBAAiB,EAAE,iCAAiC;EACtD;;AAEF;EACE,yBAAyB;EACzB,YAAY;EACZ,YAAY;EACZ,kBAAkB;EAClB,kBAAkB;EAClB,kBAAkB;EAClB,qBAAqB;EACrB,qBAAqB;EACrB,eAAe;EACf,eAAe;EACf,eAAe;EACf,kBAAkB;EAClB,SAAS;EACT,WAAW;EACX,UAAU;EACV,sBAAsB;AACxB;;AAEA;EACE,yBAAyB;AAC3B","sourcesContent":["* {\n  box-sizing: border-box;\n}\n\nbody, html {\n\n  font-family: \"Helvetica Neue\", Helvetica, Arial, sans-serif;\n\n  font-size: 12px;\n\n  height: 100%;\n  padding: 0;\n  margin: 0;\n}\n\na:link {\n  text-decoration: none;\n}\n\n.content,\n.content > div, body {\n  width: 100%;\n  height: 100%;\n  overflow: hidden;\n  display: flex;\n\n}\n\n\n.content > .message {\n  text-align: center;\n  display: table;\n\n  font-size: 16px;\n  color: #111;\n}\n\n.content > .message .note {\n  vertical-align: middle;\n  text-align: center;\n  display: table-cell;\n}\n\n.content .error .details {\n  max-width: 500px;\n  font-size: 12px;\n  margin: 20px auto;\n  text-align: left;\n}\n\n.content .error pre {\n  border: solid 1px #CCC;\n  background: #EEE;\n  padding: 10px;\n}\n\n.content:not(.with-error) .error,\n.content.with-error .intro,\n.content.with-diagram .intro {\n  display: none;\n}\n\n\n.content .canvas,\n.content.with-error .canvas {\n  visibility: hidden;\n}\n\n.content.with-diagram .canvas {\n  visibility: visible;\n}\n\n.buttons {\n  position: fixed;\n  bottom: 20px;\n  left: 20px;\n\n  padding: 0;\n  margin: 0;\n  list-style: none;\n}\n\n.buttons > li {\n  display: inline-block;\n  margin-right: 10px;\n}\n.buttons > li > a {\n  background: #DDD;\n  border: solid 1px #666;\n  display: inline-block;\n  padding: 5px;\n}\n\n.buttons a {\n  opacity: 0.3;\n}\n\n.buttons a.active {\n  opacity: 1.0;\n  cursor: pointer;\n}\n\n/* Added Styles */\n\n.cat {\n  background-size: contain;\n  background-repeat: no-repeat;\n  background-position: center;\n  width: 90%;\n  height: 90%;\n}\n\n.djs-outline {\n  visibility: hidden !important;\n}\n\n.djs-palette {\n  max-height: 90vh;\n  overflow-y: scroll;\n  width: 11rem !important;\n  /* background-color: #2F3134; */\n  border-radius: 15px;\n}\n\n.djs-palette .group {\n  margin-left: 6%;\n}\n\n.entry {\n  flex-basis: 40%;\n  margin-right: 3px;\n  margin-left: 3px;\n}\n\n\n#js-import-diagram {\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  align-content: center;\n}\n\n.icon-color-picker {\n  width: 20px;\n  height: 20px;\n}\n\n.djs-context-pad {\n  background-color: #f7f7f8;\n  padding: 10px;\n  border-radius: 15px;\n  border: 1px solid #e0e0e0;\n  width: 12rem;\n}\n\na > svg {\n  width: 25px;\n  height: 25px;\n  padding-right: 5px;\n}\n/* \n[class^=\"bpmn-icon-\"]:before, [class*=\" bpmn-icon-\"]:before {\n  color: white;\n}\n\n.djs-context-pad .entry {\n  background-color: #1f1f1f;\n}\n\n.hover, svg.new-parent, .canvas {\n  background-color: #1F1F1F !important;\n}\n\nbody, .note {\n  background-color: #1F1F1F;\n  color: white;\n}\n\n.djs-popup, .bpmn-replace {\n  background-color: #1F1F1F;\n} */\n\n.LinkEvent {\n  background-image: url('/static/link.png');\n  background-size: 75%;\n  background-repeat: no-repeat;\n  background-position: center;\n  width: 90%;\n  height: 90%;\n}\n\n.djs-resizer-n, .djs-resizer-s, .djs-resizer-w, .djs-resizer-e {\n  display: none;\n}\n\n\n/* .hover {\n  border: #111 solid 1px;\n} */\n\n.dotted-hover {\n  display: none;\n}\n\n.djs-element:hover .dotted-hover {\n  display: block;\n}\n\n.selected .dotted-hover {\n  display: block;\n}\n\n.line-selected {\n  display: none;\n}\n\n.selected .line-selected{\n  display: block;\n}\n\nrect.djs-selection-outline {\n  display: none;\n}\n\n.djs-hit {\n  cursor: default !important;\n}\n\n.drop-ok {\n  cursor: grabbing !important;\n  cursor: -webkit-grabbing !important;\n}\n\ntextarea {\n  resize: none;\n  height: 100% !important;\n  width: 100%;\n  overflow: hidden;\n}\n\n.CodeMirror {\n    height: 100%;\n    max-width: 100%;\n    color: #000;\n    overflow: hidden;\n}\n\n.json-editor {\n  position: absolute;\n  top: 0;\n  right: 0; /* Garante que a div esteja fixa no lado direito */\n  height: 100%; /* Ajuste conforme necessário */\n  border-left: 2px solid #ccc;\n  background-color: #f9f9f9;\n  min-width: 100px; /* Evita que colapse */\n  display: flex;\n  transform: translateX(100%); /* Começa fora da tela, à direita */\n  transition: transform 0.3s ease-in-out; /* Animação suave ao deslizar */\n}\n\n\n.resizer {\n  width: 10px;\n  height: 100vh;\n  cursor: ew-resize;\n  background-color: #555;\n}\n\n\n.json-content {\n  height: 100%; /* Defina a altura desejada */\n  overflow: hidden; /* Permita o overflow para scroll */\n  padding-top: 30px;\n  position: relative; \n}\n\n\n  .json-title {\n    display: flex;\n    justify-content: center; /* Center the content horizontally */\n    align-items: center;\n    padding: 5px;\n    font-weight: bold;\n    position: absolute;\n    top: 0;\n    right: 0;\n    z-index: 2;\n    width: 100%;\n    background-color: #f9f9f9;\n  }\n\n  .json-title > p {\n    margin: 0; /* Remove default margin */\n  }\n\n  .json-title > button {\n    margin-left: auto; /* Push the button to the right */\n  }\n\n#save {\n  background-color: #1c1c1c;\n  color: white;\n  border: none;\n  border-radius: 3px;\n  padding: 10px 20px;\n  text-align: center;\n  text-decoration: none;\n  display: inline-block;\n  font-size: 14px;\n  margin: 4px 2px;\n  cursor: pointer;\n  position: absolute;\n  top: 40px;\n  right: 20px;\n  z-index: 2;\n  border: #444 solid 1px;\n}\n\n#save:hover {\n  background-color: #222222;\n}\n\n\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
